import { useMediaQuery } from "react-responsive";
import { useActiveBannerMessage } from "../components/MessageBanner";

export const useHeightOffset = () => {
  const hasBanner = !!useActiveBannerMessage();
  const isMedium = useMediaQuery({ maxWidth: 1199.98 });
  const isSmall = useMediaQuery({ maxWidth: 575.98 });
  const isPrint = useMediaQuery({ query: "print" });
  const bannerHeight = isPrint
    ? 0
    : hasBanner
    ? isSmall
      ? 68
      : isMedium
      ? 54
      : 40
    : 0;
  return bannerHeight;
};
